import React, { useRef, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import {
    Affix, Badge, Button, Checkbox, CheckPicker, Col, Container, Content, DatePicker, DateRangePicker, Divider, Drawer, Dropdown, Form, Grid,
    IconButton, Input, InputGroup, InputPicker, Loader, Message, Modal, Panel, Placeholder, Popover, Progress, RadioTile, RadioTileGroup, Row, Schema, SelectPicker,
    Stack, Steps, Table, Timeline, Toggle, useToaster, Whisper
} from 'rsuite';
import axios from "axios";
import MoreIcon from '@rsuite/icons/legacy/More';
import RefreshIcon from '@rsuite/icons/legacy/Refresh';
import FilterIcon from '@rsuite/icons/legacy/Filter';
import InfoIcon from '@rsuite/icons/legacy/Info';
import PDFIcon from '@rsuite/icons/legacy/FilePdfO';
import ShareIconList from '@rsuite/icons/legacy/Share';
import CopyIcon from '@rsuite/icons/legacy/CopyO';
import DeleteIcon from '@rsuite/icons/Trash';
import RemoveIcon from '@rsuite/icons/WarningRound';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import PDFCreator from 'components/PDFCreator.js';
import VisitsIcon from 'assets/img/stats_views.svg';
import UVIcon from 'assets/img/stats_uv.svg';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import { Icon } from "@rsuite/icons";

const dateToDMYHM = (date) => {
    let d = date.getDate(), m = date.getMonth() + 1, y = date.getFullYear(), h = date.getHours(), mi = date.getMinutes();
    return '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y + ' ' + (h <= 9 ? '0' + h : h) + ':' + (mi <= 9 ? '0' + mi : mi);
}
const dateToDMY = (date) => {
    let d = date.getDate(), m = date.getMonth() + 1, y = date.getFullYear();
    return '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y;
}
const { combine, afterToday, before } = DateRangePicker;
const { Column, HeaderCell, Cell } = Table;
const PopoverFilter = React.forwardRef(({ title, callback, defaultValue, whisper, ...props }, ref) => {
    const inputRef = useRef(null);
    return (
        <Popover ref={ref} title={title} {...props} style={{ width: 300 }} arrow={false} onClick={(e) => e.stopPropagation()}>
            <InputGroup size="sm" inside style={{ width: 280 }}>
                <Input placeholder="filtrar" onKeyUp={(e) => { if (e.key === "Enter") whisper.current.close(50); }} onChange={(e) => callback(e)} defaultValue={defaultValue} autoFocus={true} ref={inputRef} />
                <InputGroup.Button onClick={() => { }}>
                    <RemoveIcon onClick={() => { inputRef.current.value = ''; callback(''); whisper.current.close(100); }} />
                </InputGroup.Button>
            </InputGroup>
        </Popover>
    );
});
const FilterHeaderCell = ({ title, popoverTitle, callback, active, ...props }) => {
    const [value, setValue] = useState("");
    const refWhisper = useRef(null);
    return (
        <HeaderCell {...props}>{title}
            <Whisper placement="auto" controlId="control-id-with-filter" trigger="click" ref={refWhisper} onClick={(e) => { e.stopPropagation(); }}
                speaker={<PopoverFilter whisper={refWhisper} title={popoverTitle} callback={(e) => { setValue(e); callback(e); }} defaultValue={value} />}>
                <div className="wise-filter">
                    <IconButton appearance="subtle" size="xs" icon={<FilterIcon color={value.length > 0 ? 'red' : ''} />} />
                </div>
            </Whisper>
        </HeaderCell>
    )
};
const LocaleDate = {
    sunday: 'Do',
    monday: 'Lu',
    tuesday: 'Ma',
    wednesday: 'Wi',
    thursday: 'Ju',
    friday: 'Vi',
    saturday: 'Sa',
    ok: 'Listo',
    today: 'Hoy',
    yesterday: 'Ayer',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    last7Days: 'Últimos 7 días'
};
const predefinedRanges = [
    {
        label: 'Hoy',
        value: [new Date(), new Date()],
        placement: 'left'
    },
    {
        label: 'Ayer',
        value: [addDays(new Date(), -1), addDays(new Date(), -1)],
        placement: 'left'
    },
    {
        label: 'Últimos 7 días',
        value: [subDays(new Date(), 6), new Date()],
        placement: 'left'
    },
    {
        label: 'Últimos 30 días',
        value: [subDays(new Date(), 29), new Date()],
        placement: 'left'
    },
    {
        label: 'Éste mes',
        value: [startOfMonth(new Date()), new Date()],
        placement: 'left'
    },
];

function CatalogList({ setWorking }) {
    const user = useSelector(state => state.auth.user)
    const site = useSelector(state => state.site);
    const apiURL = site.site.apiServer;
    const shareType = parseInt(site.site.shareType);
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [proyectName, setProyectName] = useState("");
    const [proyectHeaderText, setProyectHeaderText] = useState("OFERTA VÁLIDA HASTA AGOTAR STOCK");
    const [proyectPriceList, setProyectPriceList] = useState(-1);
    const [proyectKey, setProyectKey] = useState("");
    const [proyectDescription, setProyectDescription] = useState("");
    const [proyectPDF, setProyectPDF] = useState(false);
    const [proyectPDFWeb, setProyectPDFWeb] = useState(false);
    const [proyectActive, setProyectActive] = useState(false);
    const [proyectID, setProyectID] = useState(0);
    const [proyectStatusCode, setProyectStatusCode] = useState(0);
    const [proyectGroupType, setProyectGroupType] = useState("0");
    const [proyectUser, setProyectUser] = useState({});
    const [validityTo, setValidityTo] = useState('');
    const [selectedArticulos, setSelectedArticulos] = useState([]);
    const [loadingArticulos, setLoadingArticulos] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const [progressTitle, setProgressTitle] = useState("");
    const [progressValue, setProgressValue] = useState(0);
    const [progressTotal, setProgressTotal] = useState(0);
    const [progressPercent, setProgressPercent] = useState(0);
    const [progressStatus, setProgressStatus] = useState(null);
    const [progressMessage, setProgressMessage] = useState("");
    const [PDFWebProgress, setPDFWebProgress] = useState(false);
    const cancelPDF = useRef(false);

    const [statsV, setStatsV] = useState(0);
    const [statsUV, setStatsUV] = useState(0);

    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();

    const [soloVigentes, setSoloVigentes] = useState(false);
    const [between, setBetween] = useState([addDays(new Date(), -1), new Date()]);
    const [filteredList, setFilteredList] = useState([]);
    const [listFilters, setListFilters] = useState({ label: '', usuario: '', statusCode: '' });
    const fnSetCatalogo = (arr) => {
        setCatalogo(arr);
        setFilteredList(
            arr.filter(x =>
                (listFilters.label.length > 0 ? x.label.toLowerCase().includes(listFilters.label.toLowerCase()) : true) &&
                (listFilters.usuario.length > 0 ? x.usuario.toLowerCase().includes(listFilters.usuario.toLowerCase()) : true) &&
                (listFilters.statusCode.length > 0 ? x.statusCode.toString().toLowerCase().includes(listFilters.statusCode.toLowerCase()) : true))
        );
    }
    const fnFilterSelectedArticulos = (filters) => {
        console.log(filters);
        setListFilters(filters);
        setFilteredList(
            catalogo.filter(x =>
                (filters.label.length > 0 ? x.label.toLowerCase().includes(filters.label.toLowerCase()) : true) &&
                (filters.usuario.length > 0 ? x.usuario.toLowerCase().includes(filters.usuario.toLowerCase()) : true) &&
                (filters.statusCode.length > 0 ? x.statusCode.toString().toLowerCase().includes(filters.statusCode.toLowerCase()) : true))
        );
    }
    const fnClearFilterSelectedArticulos = () => {
        setListFilters({ label: '', usuario: '', statusCode: '' });
        setFilteredList(catalogo);
    }

    const [catalogo, setCatalogo] = useState([]);
    const [showInfo, setShowInfo] = useState(false);
    const toaster = useToaster();
    const messageCopy = (
        <Message showIcon type="success" closable>
            Vínculo copiado al portapapeles
        </Message>
    );

    const priceList = ['Sin precio', 'Lista 1', 'Lista 2', 'Lista 3', 'Lista Sucursal'];

    const handleSortColumn = (sc, st) => {
        if (sc && st) {
            console.log('sorting');
            console.log(sc);
            fnSetCatalogo([...catalogo].sort((a, b) => {
                let x = a[sc], y = b[sc];
                if (typeof x === 'string' && typeof y === 'string')
                    return st === 'asc' ? ('' + x).localeCompare(y) : ('' + y).localeCompare(x);
                return st === 'asc' ? x - y : y - x;
            }));
        }
        setSortColumn(sc);
        setSortType(st);
    };
    const TableRow = ({ children, onDrag, id, rowData, ...rest }) => {
        return (
            <div {...rest} style={{ opacity: (!rowData.active ? 0.7 : 1)}}>
                {children}
            </div>
        );
    }

    const ActionCell = ({ rowData, dataKey, ...props }) => {
        return (
            <Cell {...props} className="link-group">
                <IconButton appearance="subtle" icon={<InfoIcon />} onClick={() => {
                    setProyectName(rowData.label);
                    setProyectHeaderText(rowData.header);
                    setProyectDescription(rowData.description)
                    setProyectPriceList(rowData.priceList);
                    setProyectKey(rowData.proyectKey);
                    setSelectedArticulos([]);
                    setProyectPDF(rowData.hasPDF);
                    setProyectPDFWeb(rowData.hasPDFWeb);
                    setProyectID(rowData.value);
                    setProyectActive(rowData.active);
                    setProyectGroupType(rowData.groupType);
                    setProyectStatusCode(rowData.statusCode);

                    setValidityTo('El precio se confirmará al concretar la venta - Vigencia: ' +
                        dateToDMY(new Date(rowData.validityFrom)) + ' al ' +
                        dateToDMY(new Date(rowData.validityTo)));

                    setProyectUser({ printUser: rowData.printUser, contactEmail: rowData.contactEmail, contactName: rowData.contactName, contactPhone: rowData.contactPhone });
                    setShowInfo(true);
                }} />
            </Cell>
        );
    };

    const fetchData = async (_between) => {
        setLoading(true);
        if (_between == null)
            _between = between;
        else
            setBetween(_between);
        await axios
            .get(`${apiURL}/catalogo/list/?from=${_between[0].toISOString()}&to=${_between[1].toISOString()}`  + "", { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                console.log(response);
                fnSetCatalogo(response.data.data);
            })
            .catch((e) => { console.log(e) })
            .finally(() => setLoading(false));
    };
    const fetchStats = async () => {
        setLoading(true);
        await axios
            .get(apiURL + "/catalogo/stats/" + proyectID, { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                console.log(response);
                setStatsV(response.data.global[0].pageViews);
                setStatsUV(response.data.global[0].uniqueViews);
            })
            .catch((e) => { console.log(e) })
            .finally(() => setLoading(false));
    };
    const deletePublish = async () => {
        await axios
            .delete(`${apiURL}/catalogo/${proyectID}`, { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                if (response.data.result) {
                    setShowConfirm(false);
                    setShowInfo(false);
                    fetchData();
                    setTimeout(() => toaster.push(<Message showIcon type="success" closable>Publicaci&oacute;n eliminada</Message>, { placement: "topCenter", duration: 5000 }), 500);
                }
            })
            .catch((e) => {
                setShowConfirm(false);
                setTimeout(() => toaster.push(<Message showIcon type="error" closable>No se pudo eliminar la publiaci&oacute;n</Message>, { placement: "topCenter", duration: 5000 }), 500);
            })
    };

    const toogleActive = async (active) => {
        console.log('toogleActive');
        await axios
            .put(`${apiURL}/catalogo/${proyectKey}/?active=${active}`, { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
            .then((response) => {
                if (response.data.result) {
                    setProyectActive(active);
                    const c = catalogo.map(i => { return i.value === proyectID ? { ...i, active: active } : i });
                    console.log(c);
                    fnSetCatalogo(c);
                }
            })
            .catch((e) => console.log(e));
    }

    useEffect(() => fnFilterSelectedArticulos({ ...listFilters, statusCode: soloVigentes ? '1' : '' }), [soloVigentes])

    useEffect(() => {
        if (proyectID != 0) {
            fetchStats();
        }
    }, [proyectID]);

    useEffect(() => {
        if (loadingArticulos) {
            const fetchProducts = async () => {
                await axios
                    .get(`${apiURL}/articulo/publish/${proyectID}`, { headers: { token: JSON.parse(atob(localStorage.getItem("token"))).at }, })
                    .then((response) => {
                        setSelectedArticulos(response.data.data);
                        setShowPreview(true);
                    })
                    .catch((e) => {
                        setSelectedArticulos([]); console.log(e)
                    }).finally(() => setLoadingArticulos(false))
            };
            fetchProducts();
        }
    }, [loadingArticulos]);
    useEffect(() => {
        console.log('Catalog List begin');
        if (user.role.includes('user'))
            fetchData([addDays(new Date(), -7), new Date()]);
        else
            fetchData();
        return () => { console.log('Catalog List end'); }
    }, []);


    const createPDFWeb = async () => {
        let file = null;
        setProgressTotal(0);
        setProgressValue(0);
        setProgressStatus(null);
        setProgressTitle("Descargando PDF");

        await axios
            .get(`${site.site.apiServer}/catalogo/pdf/${proyectKey}`, {
                responseType: 'blob', withCredentials: true, onDownloadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    if (percent < 100) {
                        setProgressTotal(total);
                        setProgressValue(loaded);
                        setProgressPercent(percent.toFixed(2));
                        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
                    } else {
                        setProgressTotal(total);
                        setProgressValue(total);
                        setProgressPercent(100);
                    }
                }
            })
            .then(async (response) => {
                console.log(response.data);
                file = response.data;
                setProgressTitle("Iniciando sesión");
                setProgressTotal(file.size);
                setProgressValue(file.size);
                setProgressPercent(0);
            })
            .catch((e) => {
                console.log(e);
                return;
            });

        setProgressMessage("Trabajando en servidores externos ...");
        let token = '';
        let server = '';
        let taskID = '';
        let server_filename = ''
        let form = new FormData();
        form.append("public_key", "project_public_0a604c571d08070b53539de5f2af547b_j8mtu24653bdb162469798c6b2b22417e22de");
        await axios
            .postForm("https://api.ilovepdf.com/v1/auth", form, { 'headers': { 'Authorization': '', }, 'withCredentials': false })
            .then((response) => token = response.data.token)
            .catch((e) => {
                console.log("ERROR");
                console.log(e);
                return;
            });
        await axios
            .get("https://api.ilovepdf.com/v1/start/compress", { 'headers': { 'Authorization': 'Bearer ' + token, }, 'withCredentials': false })
            .then((response) => {
                server = response.data.server;
                taskID = response.data.task;
            })
            .catch((e) => {
                console.log("ERROR");
                console.log(e);
                return;
            });
        console.log(taskID);
        console.log(server);
        form = new FormData();
        form.append('task', taskID);
        form.append("file", file, "file.pdf");
        await axios
            .postForm('https://' + server + '/v1/upload', form, {
                'headers': { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }, 'withCredentials': false,
                onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    if (percent < 100) {
                        setProgressTotal(total);
                        setProgressValue(loaded);
                        setProgressPercent(percent.toFixed(2));
                        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
                    } else {
                        setProgressTotal(total);
                        setProgressValue(total);
                        setProgressPercent(100);
                    }
                }
            })
            .then((response) => {
                console.log(response);
                server_filename = response.data.server_filename;
                setProgressTotal(file.size);
                setProgressValue(file.size);
                setProgressPercent(100);
            })
            .catch((e) => {
                console.log("ERROR");
                console.log(e);
                return;
            });

        setProgressTitle("Comprimiendo PDF");
        console.log(server_filename);
        form = new FormData();
        form.append('task', taskID);
        form.append("tool", "compress");
        form.append('files[0][server_filename]', server_filename)
        form.append('files[0][filename]', "file.pdf")
        form.append("compression_level", "recommended");
        await axios
            .postForm('https://' + server + '/v1/process', form, { 'headers': { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }, 'withCredentials': false })
            .then((response) => {
                console.log(response);
                if (response.data.status !== "TaskSuccess") {
                    setProgressMessage("Estado: " + response.data.status);
                }
            })
            .catch((e) => {
                console.log("ERROR");
                console.log(e);
                return;
            });
        setProgressTitle("Descargando PDF");
        await axios
            .get('https://' + server + '/v1/download/' + taskID, {
                'headers': { 'Authorization': 'Bearer ' + token, }, responseType: 'blob', 'withCredentials': false,
                onDownloadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    if (percent < 100) {
                        setProgressTotal(total);
                        setProgressValue(loaded);
                        setProgressPercent(percent.toFixed(2));
                        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
                    } else {
                        setProgressTotal(total);
                        setProgressValue(total);
                        setProgressPercent(100);
                    }
                }
            })
            .then((response) => {
                setProgressTotal(0);
                setProgressValue(0);
                setProgressPercent(0);
                setProgressTitle("Guardando PDF");
                file = response.data;
                var _fileURL = window.URL.createObjectURL(file);
                let a = document.createElement("a")
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = _fileURL;
                a.download = 'catalogo_' + proyectName + '_comprimido';
                a.click();
                window.URL.revokeObjectURL(_fileURL);
            }).catch((e) => {
                console.log(e);
                return;
            });

        let fd = new FormData();
        fd.append('blobData', file, proyectKey);
        fd.append('proyectKey', proyectKey);
        fd.append('quality','low')
        await axios
            .postForm(`${apiURL}/catalogo/uploadpdf`, fd, {
                token: JSON.parse(atob(localStorage.getItem("token"))).at,
                'Content-Type': 'multipart/form-data',
                onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    if (percent < 100) {
                        setProgressTotal(total);
                        setProgressValue(loaded);
                        setProgressPercent(percent.toFixed(2));
                        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
                    }
                }
            })
            .then((response) => {
                console.log(response);
                if (response.data.result) {
                    setProgressStatus('success');
                    setProgressPercent(100);
                    setProyectPDFWeb(true);
                    setTimeout(() => {
                        setShowPreview(false);
                        setProgressStatus(null);
                        setProgressPercent(0);
                        setTimeout(() => setPDFWebProgress(false), 1000);
                    }, 500);
                    return;
                }
            })
            .catch((error) => {
                setProgressStatus('fail');
                setProgressMessage("Ocurrió un error al subir el archivo.");
                setTimeout(() => {
                    setShowPreview(false);
                    setProgressStatus(null);
                    setProgressPercent(0);
                    setProgressMessage("");
                    setTimeout(() => setPDFWebProgress(false), 1000);
                }, 1500);
            });
    }

    return (
        <>
            <Panel header={<Stack alignItems="baseline" spacing={10}>
                <Stack.Item grow={1}>
                    <h4 className="title">Catálogos ingresados</h4><small>{`Total del período: ${catalogo.length} - Listados: ${filteredList.length} - `}<strong>{`Vigentes: ${filteredList.filter(x => x.statusCode === 1).length}`}</strong></small>
                </Stack.Item>
                <div style={{fontSize:14}}>Solo vigentes <Toggle checkedChildren={<CheckIcon />} unCheckedChildren={<CloseIcon />} checked={soloVigentes} onChange={setSoloVigentes} /></div>
                <DateRangePicker format="dd-MM-yyyy" placement="auto" locale={LocaleDate} appearance="subtle" size="sm" cleanable={false} editable={false}
                    shouldDisableDate={combine(before(90), afterToday())} preventOverflow={true} ranges={predefinedRanges}
                    renderValue={(value) => ('Período ' + dateToDMY(new Date(value[0].toISOString())) + ' al ' + dateToDMY(new Date(value[1].toISOString())))}
                    onChange={(value) => fetchData(value)} value={between} defaultCalendarValue={[new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(23, 59, 59, 0))]}/>
                <Button appearance="subtle" startIcon={<RefreshIcon />} onClick={() => { fetchData(); }} />
            </Stack>} bordered>
                <Table height={150} autoHeight data={filteredList} id="table" loading={loading}
                    sortColumn={sortColumn} locale={{ emptyMessage: "Aún sin catalogos ingresados", loading: "cargando datos ..."}}
                    sortType={sortType}
                    onSortColumn={handleSortColumn} virtualized
                    renderRow={(children, rowData) => {
                        return rowData ? (
                            <TableRow
                                key={rowData.value}
                                rowData={rowData}
                                id={rowData.value}
                            >
                                {children}
                            </TableRow>
                        ) : (
                            children
                        );
                    }}>
                    <Column width={160} sortable>
                        <HeaderCell align="center">Creada</HeaderCell>
                        <Cell align="center" dataKey="dateCreated">{rowData => dateToDMYHM(new Date(rowData.dateCreated))}</Cell>
                    </Column>
                    <Column flexGrow={1} sortable>
                        <FilterHeaderCell title="Nombre" popoverTitle="Filtro por nombre" callback={(e) => {
                            fnFilterSelectedArticulos({ ...listFilters, label: e });
                        }} />
                        <Cell dataKey="label" />
                    </Column>
                    {user.role.includes('user') && (
                        <Column flexGrow={1} sortable>
                            <HeaderCell>Descripcion</HeaderCell>
                            <Cell dataKey="description" />
                        </Column>
                    )}
                    {!user.role.includes('user') && (
                        <Column flexGrow={1} sortable>
                            <FilterHeaderCell title="Usuario" popoverTitle="Filtro por nombre de usuario" callback={(e) => {
                                fnFilterSelectedArticulos({ ...listFilters, usuario: e });
                            }} />
                            <Cell dataKey="usuario" />
                        </Column>
                    )}
                    <Column width={120} sortable>
                        <HeaderCell align="center">Lista $</HeaderCell>
                        <Cell align="center" dataKey="priceList">{rowData => priceList[rowData.priceList]}</Cell>
                    </Column>
                    <Column width={80} sortable>
                        <HeaderCell align="right"># Art</HeaderCell>
                        <Cell align="right" dataKey="productCount" />
                    </Column>
                    <Column width={160} sortable>
                        <HeaderCell align="center">Desde</HeaderCell>
                        <Cell align="center" dataKey="validityFrom">{rowData => dateToDMYHM(new Date(rowData.validityFrom))}</Cell>
                    </Column>
                    <Column width={160} sortable>
                        <HeaderCell align="center">Hasta</HeaderCell>
                        <Cell align="center" dataKey="validityTo">{rowData => dateToDMYHM(new Date(rowData.validityTo))}</Cell>
                    </Column>
                    <Column width={120} sortable>
                        <HeaderCell align="center">Estado</HeaderCell>
                        <Cell align="center" dataKey="status">{rowData => rowData.active ? rowData.status : (<Badge color="red">{rowData.status}</Badge>)}</Cell>
                    </Column>
                    <Column width={50}>
                        <HeaderCell>
                            <MoreIcon />
                        </HeaderCell>
                        <ActionCell dataKey="value" />
                    </Column>
                </Table>
            </Panel>
            <Drawer backdrop="static" size="sm" placement="right" open={showInfo} onClose={() => setShowInfo(false)}>
                <Drawer.Header style={{ alignItems: "center" }}>
                    <Drawer.Title>{proyectName}</Drawer.Title>
                    <Drawer.Actions>
                        <Stack spacing={20} direction="row" alignItems="baseline" justifyContent="flex-end">
                            <Toggle disabled={proyectStatusCode != 1} checked={proyectActive} onChange={(value) => toogleActive(value)} checkedChildren="Activa" unCheckedChildren="Inactiva" />
                            <IconButton icon={<DeleteIcon />} appearance="subtle" size="sm" style={{ color: "#c00" }} onClick={() => setShowConfirm(true)} />
                        </Stack>
                    </Drawer.Actions>
                </Drawer.Header>
                <Drawer.Body>
                    <p style={{ fontWeight: "bold" }}>Descripción</p>
                    {proyectDescription.length > 0 ? (<p>{proyectDescription}</p>) : (<Placeholder.Paragraph rows={2} />)}
                    <Divider>Opciones</Divider>
                    <Timeline className="custom-timeline" endless>
                        {((!user.role.includes('user') || proyectPDF) && ((shareType & 1) == 1) && proyectStatusCode > 0) && (
                            <Timeline.Item dot={<PDFIcon style={{ color: '#333' }} />}>
                                <p>Archivo PDF</p>
                                <p>{proyectPDF ? (<>
                                    <a target="_blank" href={window.location.origin + '/pdf/' + proyectKey} className="rs-btn rs-btn-link">{window.location.origin}/pdf/{proyectKey}</a>{" "}{" "}
                                    <IconButton icon={<CopyIcon />} size="sm" onClick={() => { navigator.clipboard.writeText(window.location.origin + "/pdf/" + proyectKey); toaster.push(messageCopy, { placement: "topCenter", duration: 5000 }); }} />
                                </>) : (<>
                                    <Button disabled={loadingArticulos} appearance="link" onClick={() => setLoadingArticulos(true)}>
                                        Generar archivo PDF. <Loader style={{ marginLeft: 10, display: (loadingArticulos ? "inline-block" : "none") }} />
                                    </Button>
                                </>)}
                                </p>
                                {proyectPDF && !proyectPDFWeb && !user.role.includes('user') && (<p>
                                    <Button appearance="link" onClick={() => { setPDFWebProgress(true); createPDFWeb(); }}>
                                        Crear PDF para distribución
                                    </Button>
                                </p>)}
                                {proyectPDF && proyectPDFWeb && (
                                    <>
                                        <a target="_blank" href={window.location.origin + '/pdf/' + proyectKey} className="rs-btn rs-btn-link">{window.location.origin}/pdfweb/{proyectKey}</a>{" "}
                                        <IconButton icon={<CopyIcon />} size="sm" onClick={() => { navigator.clipboard.writeText(window.location.origin + "/pdfweb/" + proyectKey); toaster.push(messageCopy, { placement: "topCenter", duration: 5000 }); }} />
                                    </>
                                )}
                            </Timeline.Item>
                        )}
                        {((shareType & 2) == 2) && (
                            <Timeline.Item dot={<ShareIconList style={{ color: '#333' }} />}>
                                <p>Compartir en formato lista</p>
                                <p><Button appearance="link" onClick={() => { window.open(window.location.origin + '/vl/' + proyectKey); }}>
                                    {window.location.origin}/vl/{proyectKey}
                                </Button>{" "}<IconButton icon={<CopyIcon
                                    onClick={() => { navigator.clipboard.writeText(window.location.origin + "/vl/" + proyectKey); toaster.push(messageCopy, { placement: "topCenter", duration: 5000 }); }} />} size="sm" /></p>
                            </Timeline.Item>
                        )}
                        {((shareType & 4) == 4) && (
                            <Timeline.Item dot={<ShareIconList style={{ color: '#333' }} />}>
                                <p>Compartir en formato hoja de catálogo</p>
                                <p><Button appearance="link" onClick={() => { window.open(window.location.origin + '/vc/' + proyectKey); }}>
                                    {window.location.origin}/vc/{proyectKey}
                                </Button>{" "}<IconButton icon={<CopyIcon
                                    onClick={() => { navigator.clipboard.writeText(window.location.origin + "/vc/" + proyectKey); toaster.push(messageCopy, { placement: "topCenter", duration: 5000 }); }} />} size="sm" /></p>
                            </Timeline.Item>
                        )}
                    </Timeline>
                    <Divider>Estadísticas</Divider>
                    <Stack alignItems="center" spacing={20}>
                        <Stack.Item grow={1} style={{ position: "relative", padding: 5, backgroundColor: "var(--rs-gray-100)"}}>
                            <img src={VisitsIcon} style={{ position: "absolute", width: 100, top: 10, opacity: .5}} />
                            <div style={{ textAlign: "right" }}>Visitas</div>
                            <div style={{ textAlign: "right", fontSize: "24px", fontWeight: "bold", paddingRight: 5 }}>{statsV}</div>
                        </Stack.Item>
                        <Stack.Item grow={1} style={{ position: "relative", padding: 5, backgroundColor: "var(--rs-gray-100)" }}>
                            <img src={UVIcon} style={{ position: "absolute", width: 100, top: 10, opacity: .5 }} />
                            <div style={{ textAlign: "right" }}>Visitas únicas</div>
                            <div style={{ textAlign: "right", fontSize: "24px", fontWeight: "bold", paddingRight: 5 }}>{statsUV}</div>
                        </Stack.Item>
                    </Stack>
                </Drawer.Body>
            </Drawer>
            <Drawer backdrop="static" size="xs" placement="top" open={PDFWebProgress} onClose={() => { setPDFWebProgress(false); cancelPDF.current = true; }}>
                <Drawer.Header>
                    <Drawer.Title>Generando PDF WEB</Drawer.Title>
                    <Drawer.Actions>
                        <Button onClick={() => { setPDFWebProgress(false); cancelPDF.current = true; }}>Cancelar</Button>
                    </Drawer.Actions>
                </Drawer.Header>
                <Drawer.Body>
                    <Row>
                        <Col md={6} mdOffset={3} style={{padding: 10}}>
                            {progressTitle}
                            {progressValue != progressTotal && (
                                <>
                                    {progressValue} de {progressTotal}
                                </>
                            )}
                        </Col>
                        <Col md={12}>
                            <Progress.Line percent={progressPercent}
                                strokeColor={progressPercent === 100 ? '#52c41a' : '#3385ff'} status={progressStatus} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} mdOffset={6}>
                            <h6>{progressMessage}</h6>
                        </Col>
                    </Row>
                </Drawer.Body>
            </Drawer>
            <Modal backdrop="static" keyboard={true} open={showConfirm} onClose={() => setShowConfirm(false)}>
                <Modal.Header>
                    <Modal.Title>Confirmaci&oacute;n</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro de eliminar la publicación seleccionada?"
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => deletePublish()} appearance="primary">
                        Aceptar
                    </Button>
                    <Button onClick={() => setShowConfirm(false)} appearance="subtle">
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
            <PDFCreator
                showPreview={showPreview}
                setShowPreview={setShowPreview}
                selectedArticulos={selectedArticulos}
                proyectKey={proyectKey}
                proyectHeaderText={proyectHeaderText}
                proyectName={proyectName}
                proyectPriceList={proyectPriceList}
                setProyectPDF={setProyectPDF}
                proyectGroupType={proyectGroupType}
                proyectUser={proyectUser}
                validityTo={validityTo}
            />
        </>
    );
}

export default CatalogList;